module.exports = __webpack_public_path__ + "static/media/grand_mum_why-aren_t-you-eating.202b2d65.png";